export default async function fetchInstructionListsForPackages(
  client,
  packages
) {
  if (!packages.length) {
    return [];
  }

  const instructionLists = await Promise.all(
    packages.map((pkg) =>
      client
        .get(`/work-instructions/package/${pkg._id}`)
        .then((response) => response.data || [])
        .catch(() => [])
    )
  );

  return instructionLists;
}
